@if (isLoading) {
  <div class="floating-card-content">
    <via-loading-indicator></via-loading-indicator>
  </div>
} @else if (displayWidget; as widget) {
  @if (widget.showHeader) {
    <div class="floating-card-header">
      <div class="header-left">
        @if (widget.illustrationType === 'icon'  && widget.icon) {
          <mat-icon class="floating-card-icon">{{ widget.icon }}</mat-icon>
        }

        @if (widget.illustrationType === 'themed-image' && themedSvgHtml) {
          <span class="themed-illustration" [innerHTML]="themedSvgHtml"></span>
        }

        @if (widget.title) {
          <h3 class="floating-card-title">{{ widget.title }}</h3>
        }
      </div>

      @if (canCloseWidget) {
        <button class="floating-card-close" (click)="closeClicked.emit()" aria-label="Close">
          <mat-icon class="close-icon">close</mat-icon>
        </button>
      }
    </div>
  }

  <div
    class="floating-card-content"
    [class.table-content]="(widget.tables?.length ?? 0) > 0">
    <div class="image-container">
      @if (widget.image && widget.image.position === 'top') {
        <img
          class="card-image"
          [src]="widget.image.src"
          [attr.alt]="widget.image.alt || widget.title || ''"
          [style.height]="widget.image.height || 'auto'"/>
      }
    </div>

    @if (widget.charts?.length) {
       @for (chart of widget.charts; track chart) {
         <via-basic-chart [type]="chart.type" [data]="chart.data"></via-basic-chart>
       }
    }

    @if (widget.tables?.length) {
      @if (widget.tables?.length === 1 && primaryTable) {
        <via-dynamic-material-table
          [widgetKey]="widget.widgetKey"
          [widgetTable]="primaryTable"
          [data]="getDataset(primaryTable)"
          [showErrorState]="showErrorState">
        </via-dynamic-material-table>
      }
      @else {
        <mat-tab-group
          id="tab-group"
          class="widget-tab-group"
          mat-stretch-tabs="false"
          animationDuration="300ms">
          @for (table of widget.tables; track table.orderIndex) {
            <mat-tab [label]="table.title">
              <via-dynamic-material-table
                [widgetKey]="widget.widgetKey"
                [widgetTable]="table"
                [data]="getDataset(table)"
                [showErrorState]="showErrorState">
              </via-dynamic-material-table>
            </mat-tab>
          }
        </mat-tab-group>
      }
    }
    @else {
      <p>{{ widget.body }}</p>
    }

    @if (widget.image && widget.image.position === 'bottom') {
      <img
        class="card-image card-image-bottom"
        [src]="widget.image.src"
        [attr.alt]="widget.image.alt || widget.title || ''"
        [style.height]="widget.image.height || 'auto'"/>
    }
  </div>

  @if (widget.showFooter) {
    <div class="floating-card-footer">
      <ng-content select="[slot=footer]">
        <button>Cancel</button>
        <button>Save</button>
      </ng-content>
    </div>
  }
}
